import { useStore } from 'context/store'
import { useTranslation } from 'react-i18next'

type ScanHeaderProps = {
  onHeaderClose: () => void
  eventTitle?: string
  checkedInCount?: number
  registeredCount?: number
}

export default function ScanHeader({
  onHeaderClose,
  eventTitle: eventTitleProp,
  checkedInCount: checkedInCountProp,
  registeredCount: registeredCountProp,
}: ScanHeaderProps) {
  const { t } = useTranslation()
  const {
    eventRegistrationStore: { currentEvent },
  } = useStore()

  const title = eventTitleProp ?? currentEvent?.title
  const checkedIn = checkedInCountProp ?? currentEvent?.checkedInCount ?? 0
  const registered =
    registeredCountProp ??
    currentEvent?.registeredCount ??
    currentEvent?.registeredQuantityEvent ??
    0
  const remaining = Math.max(0, registered - checkedIn)

  return (
    <header className="scan-qr-header">
      <div className="flex justify-content-between align-items-start gap-2">
        <div className="flex-1 min-w-0">
          <h2 className="m-0 text-xl text-white">{t('Scan QR code')}</h2>
          {title ? (
            <p className="m-0 mt-1 text-sm text-300 white-space-normal">
              {title}
            </p>
          ) : null}
        </div>
        <button
          type="button"
          className="scan-qr-close p-2 border-none bg-transparent text-white cursor-pointer border-round"
          onClick={onHeaderClose}
          aria-label={t('Close')}
        >
          <i className="isax-close-01 text-2xl" />
        </button>
      </div>
      <div className="scan-qr-status text-white">
        <i className="isax-tick-circle scan-qr-status__icon-ok" />
        <span>
          {t('Checked in: {{current}} / {{total}}', {
            current: checkedIn,
            total: registered,
          })}
        </span>
        <span className="mx-1 opacity-60">·</span>
        <span>
          {t('Remaining: {{count}}', {
            count: remaining,
          })}
        </span>
      </div>
    </header>
  )
}
